import { UpSquareOutlined } from '@ant-design/icons';
import { Radio } from 'antd';
import OrderMethodItem from 'components/pages/dashboard/ParcelOrder/components/orderMethods/OrderMethodItem';
import { orderMethodsState } from 'components/pages/dashboard/ParcelOrder/ParcelOrder';
import { packageCreate } from 'global/Models/omOrderModel';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPickupTypes } from 'redux/reducer/ParcelOrder/getPickupTypes';
import { RootState, store } from 'redux/store';

interface IOrderMethodPickupType {
  pickupTypeId?: number;
  handleChange?: (_values: Partial<orderMethodsState>) => void;
  packages?: packageCreate[];
}

const OrderMethodPickupType: FC<IOrderMethodPickupType> = ({ pickupTypeId, handleChange, packages }) => {
  const { pickupTypes } = useSelector((state: RootState) => state.parcelOrder);

  const params = new URLSearchParams(window.location.search);
  const lockToBranchPickup = params.get('branch') === 'true';
  const hasEcoPack = packages?.some((item) => item?.package?.some((pkg) => pkg?.packagingGroupId === 70));
  const filteredPickupType = pickupTypes?.filter((item) => item.id)?.filter((item) => !(hasEcoPack && item.id === 10));

  useEffect(() => {
    if (!pickupTypes) store.dispatch(getPickupTypes());
  }, []);

  useEffect(() => {
    if (!filteredPickupType?.length || !handleChange) return;

    const validIds = filteredPickupType.map((i) => i.id);

    if (!pickupTypeId || !validIds.includes(pickupTypeId)) {
      const defaultId = hasEcoPack ? validIds[0] : validIds.includes(10) ? 10 : validIds[0];

      handleChange({ pickupTypeId: defaultId });
    }
  }, [filteredPickupType, pickupTypeId, hasEcoPack]);

  return (
    <>
      <OrderMethodItem icon={<UpSquareOutlined className='text-2xl' />} title='نحوه جمع آوری'>
        <div className='flex flex-col gap-4 sm:flex-row'>
          {filteredPickupType?.map((item) => {
            const isDisabled = lockToBranchPickup && item.id !== 20;

            return (
              <div
                key={item.id}
                className={`px-4 py-2 flex gap-2 items-center w-full md:w-fit border rounded-md
                ${isDisabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:border-t-primary-color'}
                ${pickupTypeId === item.id && 'border-t-primary-color'}
              `}
                onClick={() => {
                  if (isDisabled) return;
                  handleChange && handleChange({ pickupTypeId: item.id });
                }}>
                <Radio checked={pickupTypeId === item.id} disabled={isDisabled} />
                {item.title}
              </div>
            );
          })}
        </div>
      </OrderMethodItem>
    </>
  );
};

export default OrderMethodPickupType;
